document.addEventListener('DOMContentLoaded', function() {
  const customLocalizationForms = document.querySelectorAll('.custom-localization-form');

  customLocalizationForms.forEach(customLocalizationForm => {
    const localizationFormItemButton = customLocalizationForm.querySelector('.localization-form__item-button');
    const langListHeader = customLocalizationForm.querySelector('.localization-list');

    const closeForm = () => {
      customLocalizationForm.style.zIndex = '';
      customLocalizationForm.classList.remove('active');
      if (localizationFormItemButton) {
        localizationFormItemButton.setAttribute('aria-expanded', 'false');
      }
      if (langListHeader) {
        langListHeader.classList.remove('content-opened');
      }
    };

    if (customLocalizationForm) {
      customLocalizationForm.addEventListener('click', function(event) {
        if (event.target.closest('.localization-form__item-button') && customLocalizationForm.style.zIndex === '50') {
          closeForm();
        } else if (customLocalizationForm.style.zIndex !== '50') {
          customLocalizationForm.style.zIndex = '50';
          customLocalizationForm.classList.add('active');
          if (localizationFormItemButton) {
            localizationFormItemButton.setAttribute('aria-expanded', 'true');
          }
          if (langListHeader) {
            langListHeader.classList.add('content-opened');
          }
        }
      });

      if (langListHeader) {
        langListHeader.addEventListener('click', function(event) {
          closeForm();
        });
      }

      document.addEventListener('click', function(event) {
        if (!customLocalizationForm.contains(event.target) && customLocalizationForm.style.zIndex === '50') {
          closeForm();
        }
      });
    }
  });
});